import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { login, menu } from '@/api/user'
Vue.use(Vuex)

export default new Vuex.Store({
  // 持续化
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: 'store',
      render (state) {
        return { ...state }
      }
    })
  ],
  // 数据
  state: {
    token: '',
    userInfo: '',
    menu: {
      home: '',
      menuPermission: [],
      titlelist: {},
      buttonPermission: {}
    },
    isCollapse: false,
    theme: false
  },
  // getters
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    menu: state => state.menu,
    menuPermission: state => state.menu.menuPermission || [],
    titlelist: state => state.menu.titlelist || {},
    buttonPermission: (state) => {
      return state.menu.res.permissions
    },
    home: state => state.menu.home || '/',
    isCollapse: state => state.isCollapse,
    theme: state => state.theme
  },
  // mutations
  mutations: {
    set_token: (state, token) => {
      state.token = token
    },
    set_userInfo: (state, userInfo) => {
      state.userInfo = userInfo
    },
    set_menu: (state, menu) => {
      state.menu = menu
    },
    set_isCollapse: (state, isCollapse) => {
      state.isCollapse = isCollapse
    },
    set_theme: (state, theme) => {
      state.theme = theme
    }

  },
  // actions
  actions: {
    login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login({ ...userInfo }).then(res => {
          
          commit('set_token', res.bearer_token)
          commit('set_userInfo', res.admin_info)
          menu().then((res) => {
            res.nodes.unshift({
              component: '/index/index',
              icon: '',
              id: 99999,
              path: 'index/index',
              pid: 0,
              sort: 1,
              title: '欢迎',
              type: 1,
              children: [{
              //   component: '/index/index/login',
              //   icon: '',
              //   id: 9999,
              //   path: '/index/index/login',
              //   pid: 0,
              //   sort: 9999,
              //   title: '欢迎您！',
              //   type: 1
              // }, {
                component: '/index/index/info',
                icon: '',
                id: 8888,
                path: '/index/index/info',
                pid: 0,
                sort: 8888,
                title: '个人信息',
                type: 1
              }]
            })
            let home = '/'
            // const buttonPermission = {}
            const menuPermission = []
            const titlelist = {}
            let serveApi = {}
            function splitPermission (nodes, arr) {
              nodes.forEach(item => {
                if (item.type === 1) {
                  const { id, title, component, icon, children } = item
                  // 菜单
                  const obj = {
                    id, title, component, icon
                  }
                  titlelist[component] = title
                  arr.push(obj)
                  if (children) {
                    obj.children = []
                    splitPermission(children, obj.children)
                  }
                }
                serveApi = {
                  ...serveApi,
                  [item.id]: item.path
                }
                Vue.prototype.$serve = serveApi
                localStorage.setItem('serve', JSON.stringify(serveApi))
              })
            }

            function getHome (menu) {
              const one = menu[0]
              if (one) {
                if (one.children && one.children.length) {
                  getHome(one.children)
                } else {
                  home = one.component
                }
              }
            }
            splitPermission(res.nodes || [], menuPermission)

            getHome(menuPermission)

            commit('set_menu', {
              res,
              home,
              // buttonPermission,
              menuPermission,
              titlelist
            })
            resolve()
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    logout ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('set_token', '')
        commit('set_userInfo', '')
        commit('set_menu', '')
        commit('set_isCollapse', false)
        commit('set_theme', false)
        resolve()
      })
    }
  },
  // 模块
  modules: {
  }
})
